import { render, staticRenderFns } from "./Centered.vue?vue&type=template&id=f21dc2ae&scoped=true&"
import script from "./Centered.vue?vue&type=script&lang=ts&"
export * from "./Centered.vue?vue&type=script&lang=ts&"
import style0 from "./Centered.vue?vue&type=style&index=0&id=f21dc2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21dc2ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
